<template>
  <div class="uploadDocuments">
    <van-sticky>
      <div
        class="uploadDocumentsNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">上传缴费凭证</span>
      </div>
    </van-sticky>
    <div class="content">
      <h3>上传缴费凭证</h3>
      <div class="item">
        <p>代理费</p>
        <span v-if="data.config">{{ data.config.enterpriseAgentCost }}元</span>
      </div>
      <div class="card" v-if="data.config">
        <p>装饰代理费收款账户信息：</p>
        <div v-if="data.config.label == '支付宝账户'">
          <p>
            支付宝名称：<span>{{ data.config.companyName }}</span>
          </p>
          <p>
            支付宝账号：<span>{{ data.config.bankNumber }}</span>
          </p>
        </div>
        <div v-else>
          <p>
            账户名称：<span>{{ data.config.companyName }}</span>
          </p>
          <p>
            开户行：
            <span>{{ data.config.openAccountBank }}</span>
          </p>
          <p>
            银行卡号：
            <span>{{ data.config.bankNumber }}</span>
          </p>
        </div>
        <img src="./../../../assets/decoration/order/hsj.png" alt="" />
      </div>
      <div class="imgUplod">
        <div class="imgUplodTop">
          <p>代理费缴费凭证</p>
          <span>请上传1～5张缴费凭证，格式jpg，jpeg，png ，大小控制在5M</span>
        </div>
        <div class="imgUplodBtm">
          <van-uploader
            v-model="fileList1"
            :max-count="5"
            accept="image/jpeg, image/jpg, image/png"
            multiple
            :max-size="10 * 1024 * 1024"
            :after-read="afterRead"
            :before-read="beforeRead"
            @oversize="onOversize"
          >
            <div class="box">
              <img src="./../../../assets/decoration/order/addImg.png" />
            </div>
          </van-uploader>
        </div>
      </div>
      <div class="imgUplodTip">
        <img src="./../../../assets/decoration/tip.png" alt="" />
        <p>
          务必使用与认证资料主体同名的对公银行账户进行打款，否则会审核失败！
        </p>
      </div>
      <div class="time">
        <div class="selectTime">
          <p>支付时间</p>
          <img
            @click="selectTimeTip = !selectTimeTip"
            src="./../../../assets/decoration/order/tip.png"
            alt=""
          />
          <span
            @click="datetimePicker()"
            :style="{
              color: time ? '#333333' : '#CACDE0',
              fontWeight: time ? 'bold' : 'normal',
            }"
            >{{ time ? time : "请选择支付时间" }}</span
          >
          <img src="./../../../assets/decoration/order/rl.png" alt="" />
        </div>
        <div class="selectTimeTip" v-if="selectTimeTip">
          <p>支付时间为公对公线下缴纳代理费时间。</p>
          <p>支付时间为合同的服务开始时间，请正确输入。</p>
          <img src="./../../../assets/decoration/order/ysj.png" alt="" />
        </div>
      </div>
      <!-- 底部提交按钮 -->
      <div class="btmSubmit">
        <img
          src="./../../../assets/decoration/more.png"
          alt=""
          @click="isShowClose = !isShowClose"
        />
        <button @click="submit()">确认并提交</button>
        <div class="moreMenu" v-if="isShowClose">
          <span @click="closeOrder()">取消订单</span>
        </div>
      </div>
    </div>
    <van-action-sheet v-model="pickerShow" @close="closePicker()">
      <div class="pickerShowTop">
        <div>
          <span
            @click="switchDate(1)"
            :style="{
              borderBottom: pickerProgress == 1 ? '3px solid #5853E9' : 'none',
            }"
            >{{ nyrDate }}</span
          >
          <span
            @click="switchDate(2)"
            :style="{
              borderBottom: pickerProgress == 2 ? '3px solid #5853E9' : 'none',
            }"
            >{{ sfmDate }}</span
          >
        </div>
        <button @click="datetimePickerConfim()">确认</button>
      </div>
      <!-- 年月日 -->
      <div class="sheetNYR" v-if="pickerProgress == 1">
        <van-calendar
          :poppable="false"
          :show-confirm="false"
          :show-title="false"
          :show-subtitle="false"
          :min-date="minDate"
          :max-date="maxDate"
          :default-date="defaultDate"
          :row-height="44"
          color="#5853E9"
          :style="{ height: '350px' }"
          @select="selectNYR($event)"
        />
      </div>
      <!-- 时分秒 -->
      <div class="sheetSFM" v-if="pickerProgress == 2">
        <van-picker :columns="sfmColumns" @change="selectSFM" />
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import Upload from "./../../../providers/upload";
export default {
  data() {
    return {
      isiOSX: false,
      payLoading: false,
      fileList1: [],
      selectTimeTip: false,
      data: {},
      defaultDate: new Date(),
      nyrDate: "",
      sfmDate: "",
      time: "",
      pay_time: "",
      pickerShow: false,
      pickerProgress: 1,
      minDate: new Date("2022/01/01"),
      maxDate: new Date(),
      sfmColumns: [
        // 第一列
        {
          values: [],
          defaultIndex: 0,
        },
        // 第二列
        {
          values: [],
          defaultIndex: 0,
        },
        // 第三列
        {
          values: [],
          defaultIndex: 0,
        },
      ],
      isShowClose: false,
      city_agent_id: null,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    this.sfmFormatting();
    this.getConfigData();
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取配置信息
    getConfigData() {
      this.$api
        .post("decoration/member/city/agent/get/money", {
          code: "EnterpriseAgentConfig",
          type: 2,
        })
        .then((res) => {
          this.data = res;
        });
    },
    // 获取代理人id
    getData() {
      this.$api
        .get("decoration/member/city/agent/enterprise/info")
        .then((res) => {
          this.city_agent_id = res.enterprise_info.city_agent_id;
        });
    },
    beforeRead(file) {
      if (file.size == 0 || JSON.stringify(file.file) == "{}") {
        //解决部分机型取消上传还是添加空白图片
        return false;
      } else {
        return true;
      }
    },
    afterRead(file) {
      if (Array.isArray(file)) {
        // 多选
        file.forEach((item) => {
          this.imgUpload(item);
        });
      } else {
        // 单选
        this.imgUpload(file);
      }
    },
    onOversize(file) {
      this.$toast("上传文件大小请控制在5M内");
    },
    // 图片上传
    imgUpload(file) {
      file.status = "uploading";
      file.message = "上传中...";
      Upload.upload(file.file, ["others"])
        .then((res) => {
          file.status = "";
          file.message = "";
          file.url = res;
        })
        .catch((res) => {
          file.status = "failed";
          file.message = "失败";
        });
    },
    // 打开时间选择器
    datetimePicker() {
      if (this.pay_time) {
        this.switchDate(1);
      } else {
        this.getCurrentDate();
      }
      this.pickerProgress = 1;
      this.pickerShow = true;
    },
    // 关闭时间选择器
    closePicker() {
      this.pickerShow = false;
    },
    // 获取当前时间
    getCurrentDate() {
      let currentDate = new Date();
      this.defaultDate = currentDate;
      this.nyrDate = `${currentDate.getFullYear()}年${
        currentDate.getMonth() + 1 > 9
          ? currentDate.getMonth() + 1
          : `0${currentDate.getMonth() + 1}`
      }月${
        currentDate.getDate() > 9
          ? currentDate.getDate()
          : `0${currentDate.getDate()}`
      }日`;
      let h =
        currentDate.getHours() > 9
          ? currentDate.getHours()
          : `0${currentDate.getHours()}`;
      let f =
        currentDate.getMinutes() > 9
          ? currentDate.getMinutes()
          : `0${currentDate.getMinutes()}`;
      let m =
        currentDate.getSeconds() > 9
          ? currentDate.getSeconds()
          : `0${currentDate.getSeconds()}`;
      this.sfmDate = `${h}:${f}:${m}`;
    },
    //   时分秒格式化
    sfmFormatting() {
      for (let s = 0; s < 24; s++) {
        if (s < 10) {
          this.sfmColumns[0].values.push(`0${s}`);
        } else {
          this.sfmColumns[0].values.push(s);
        }
      }
      for (let j = 0; j < 60; j++) {
        if (j < 10) {
          this.sfmColumns[1].values.push(`0${j}`);
          this.sfmColumns[2].values.push(`0${j}`);
        } else {
          this.sfmColumns[1].values.push(j);
          this.sfmColumns[2].values.push(j);
        }
      }
    },
    // 年月日 时分秒切换
    switchDate(type) {
      if (type == 1) {
        this.pickerProgress = 1;
        // defaultDate
      } else if (type == 2) {
        let activeH = this.sfmDate.substring(0, 2);
        let activeF = this.sfmDate.substring(3, 5);
        let activeM = this.sfmDate.substring(6, 8);
        this.sfmColumns[0].values.forEach((item, index) => {
          if (item == activeH) {
            this.sfmColumns[0].defaultIndex = index;
          }
        });
        this.sfmColumns[1].values.forEach((item, index) => {
          if (item == activeF) {
            this.sfmColumns[1].defaultIndex = index;
          }
        });
        this.sfmColumns[2].values.forEach((item, index) => {
          if (item == activeM) {
            this.sfmColumns[2].defaultIndex = index;
          }
        });
        this.pickerProgress = 2;
      }
    },
    // 年月日选择
    selectNYR(e) {
      this.nyrDate = `${e.getFullYear()}年${
        e.getMonth() + 1 > 9 ? e.getMonth() + 1 : `0${e.getMonth() + 1}`
      }月${e.getDate() > 9 ? e.getDate() : `0${e.getDate()}`}日`;
      this.defaultDate = e;
    },
    // 时分秒选择
    selectSFM(value, index) {
      this.sfmDate = `${index[0]}:${index[1]}:${index[2]}`;
    },
    // 确定选中日期
    datetimePickerConfim() {
      this.time = `${this.nyrDate} ${this.sfmDate}`;
      let nian = this.nyrDate.substring(0, this.nyrDate.indexOf("年"));
      let yue = this.nyrDate.substring(
        this.nyrDate.indexOf("年") + 1,
        this.nyrDate.indexOf("月")
      );
      let ri = this.nyrDate.substring(
        this.nyrDate.indexOf("月") + 1,
        this.nyrDate.indexOf("日")
      );
      this.pay_time = `${nian}-${yue}-${ri} ${this.sfmDate}`;
      this.closePicker();
    },
    // 取消订单
    closeOrder() {
      this.$dialog
        .confirm({
          title: "确认关闭代理人申请？",
          message: "点击确定后，该订单将关闭",
          width: "280px",
          confirmButtonColor: "#5853E9",
          cancelButtonColor: "rgba(88, 83, 233, .1)",
          theme: "round-button",
        })
        .then(() => {
          this.$api.get("decoration/basic/csrf/token").then((res) => {
            this.$api
              .post("decoration/member/city/agent/close/apply", {
                id: this.city_agent_id,
                csrf_token: res.csrf_token,
              })
              .then((res) => {
                this.goBack();
              });
          });
        })
        .catch(() => {});
    },
    submit() {
      let pay_voucher_end = false;
      let pay_voucher = [];
      this.fileList1.forEach((item, index) => {
        if (item.url) {
          pay_voucher.push(item.url);
        } else {
          this.$toast("文件正在上传中，请稍等");
          pay_voucher_end = true;
          return;
        }
      });
      if (pay_voucher_end) {
        return;
      }
      this.payLoading = true;
      this.$api.get("decoration/basic/csrf/token").then((res) => {
        this.$api
          .post("decoration/member/city/agent/submit/pay/voucher", {
            pay_time: this.pay_time,
            pay_voucher: pay_voucher,
            csrf_token: res.csrf_token, //类型：String  必有字段  备注：防重复token
          })
          .then((res) => {
            this.$router.push({
              path: "/decoration/deputy/details",
            });
            this.payLoading = false;
          })
          .catch((err) => {
            this.ThrowError(err);
            this.payLoading = false;
          });
      });
    },
    ThrowError(err) {
      let keys = Object.keys(err);
      let key = keys[0];
      let message = err.message || err[key][0];
      if (message.slice(0, 10) == "timeout of") {
        this.$toast("网络不给力，请稍候重试");
      } else {
        this.$toast(message);
      }
      return;
    },
  },
};
</script>
<style lang="less" scoped>
.uploadDocuments {
  min-height: 100%;
  background: #f2f2f2;
  color: #333;
  padding-bottom: 125px;
  h3 {
    margin: 0;
  }
  .uploadDocumentsNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
  }
  .content {
    margin: 12px 16px;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 24px 16px;
    h3 {
      display: inline-block;
      font-size: 20px;
      font-weight: 700;
      color: #333333;
      border-bottom: 5px solid #d2c3ff;
      margin: 0 4px;
      height: 20px;
      align-self: flex-start;
    }
    .item {
      display: flex;
      justify-content: space-between;
      height: 20px;
      font-size: 14px;
      color: #333333;
      margin: 24px 8px 0;
      span {
        font-weight: 700;
      }
    }
    .card {
      background: #f7f8ff;
      border-radius: 8px;
      margin-top: 16px;
      padding: 12px 22px;
      position: relative;
      p {
        font-size: 13px;
        color: #666666;
        line-height: 22px;
        span {
          font-weight: bold;
        }
      }
      img {
        width: 28px;
        height: 14px;
        position: absolute;
        top: -14px;
        left: 34px;
      }
    }
    .imgUplod {
      margin-top: 25px;
      .imgUplodTop {
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        p {
          flex-shrink: 0;
          margin-right: 12px;
        }
        span {
          color: #999999;
          font-size: 12px;
        }
      }
      .imgUplodBtm {
        display: flex;
        margin-top: 16px;
        img {
          width: 60px;
          height: 60px;
        }
        ::v-deep .van-uploader__preview {
          margin: 0 3px 4px 0;
        }
        ::v-deep .van-uploader__preview-image,
        ::v-deep .van-uploader__file {
          width: 60px;
          height: 60px;
        }
      }
    }
    .imgUplodTip {
      margin-top: 16px;
      background: #faf6f1;
      border-radius: 4px;
      display: flex;
      padding: 6px;
      img {
        width: 12px;
        height: 12px;
        margin: 2px 5px 0 0;
      }
      p {
        font-size: 12px;
        color: #c38e58;
        line-height: 17px;
      }
    }
    .time {
      margin: 26px 0px 0;
      .selectTime {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #666666;
        padding: 10px 16px;
        background-color: #f7f8ff;
        border-radius: 6px;
        p {
        }
        span {
          flex: 1;
          margin: 0 8px;
          font-weight: bold;
        }
        img {
          width: 16px;
          height: 16px;
        }
      }
      .selectTimeTip {
        padding: 10px 12px;
        font-size: 13px;
        color: #ff7e31;
        line-height: 18px;
        background: #ffdecb;
        border-radius: 6px;
        position: relative;
        margin-top: 5px;
        img {
          width: 23px;
          height: 10px;
          position: absolute;
          top: -10px;
          left: 69px;
        }
      }
    }
    .btmSubmit {
      width: 100%;
      height: 83px;
      position: fixed;
      left: 0;
      bottom: 0;
      background-color: #ffffff;
      display: flex;
      box-shadow: inset 0px 1px 0px 0px #f7f8fc;
      img {
        width: 24px;
        height: 24px;
        margin: 11px 0 11px 20px;
      }
      button {
        height: 46px;
        flex: 1;
        margin: 2px 16px;
        border: none;
        background: #5853e9;
        border-radius: 25px;
        font-size: 16px;
        font-weight: 500;
        color: #ffffff;
      }
      .moreMenu {
        position: absolute;
        top: -41px;
        left: 11px;
        display: flex;
        flex-direction: column;
        span {
          background: rgba(51, 51, 51, 0.9);
          width: 104px;
          line-height: 36px;
          text-align: center;
          height: 36px;
          border-radius: 8px;
          font-size: 14px;
          color: #ffffff;
        }
      }
    }
  }
  .pickerShowTop {
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    box-shadow: inset 0px -9px 10px -16px #000;
    div {
      display: flex;
      align-items: center;
      span {
        display: inline-block;
        height: 100%;
        padding: 0 16px;
        font-size: 14px;
        color: #969799;
        line-height: 41px;
      }
    }
    button {
      color: #5853e9;
      height: 100%;
      padding: 0 16px;
      font-size: 14px;
      border: none;
      background-color: transparent;
    }
  }
  .sheetNYR,
  .sheetSFM {
    height: 350px;
    display: flex;
    align-items: center;
    .van-picker {
      flex: 1;
    }
  }
}
</style>
<style>
.van-dialog__confirm,
.van-dialog__cancel {
  margin: 0 8px;
  border-radius: 18px;
}
.van-dialog__cancel {
  color: #5853e9 !important;
}
</style>